import CSessao from './CSessao';
import CStorage from './CStorage';
import type { IFiltroAPI } from '../api/base/CFiltro';
import { type TFiltroFavoritoStorage } from '../base/CBaseMapeamento';

// Components
import { type TTipoGraficoInterno } from '@/components/dados/apex/ApexCharts';

// Enums
import ECodificacao from '@/shared/enums/ECodificacao';
import ETemaAplicacao from '@/shared/enums/ETemaAplicacao';

const cCHAVE_FILTROS_TEMA: string = 'FiltrosTema';
const cCHAVE_TEMA_APLICACAO: string = 'TemaAplicacao';
const cCHAVE_CONFIG_EXIBICAO: string = 'ConfigExibicao';
const cCHAVE_AVISO_ATUALIZACAO: string = 'AvisoAtualizacao';
const cCHAVE_NOVIDADE_ATUALIZACAO: string = 'NovidadeAtualizacao';

export const cCHAVE_FILTROS_FAVORITOS: string = 'FiltrosFavoritos';

export const cCHAVE_FILTROS_TEMA_ADMINISTRATIVO_MONITORAMENTO_CONEXOES =
  ECodificacao.TemaAdministrativo + '_MonitoramentoConexoes';

export const cCHAVE_FILTROS_TEMA_ADMINISTRATIVO_FREQUENCIA_ACESSO =
  ECodificacao.TemaAdministrativo + '_Relatorio_FrequenciaAcesso';

export const cCHAVE_FILTROS_TEMA_ADMINISTRATIVO_FREQUENCIA_ATUALIZACAO =
  ECodificacao.TemaAdministrativo + '_Relatorio_FrequenciaAtualizacao';

export const cCHAVE_FILTROS_TEMA_ADMINISTRATIVO_NECESSIDADE_CARGA_INICIAL =
  ECodificacao.TemaAdministrativo + '_Relatorio_NecessidadeNovaCargaInicial';

export const cCHAVE_FILTROS_TEMA_ADMINISTRATIVO_TEMPO_DE_USO =
  ECodificacao.TemaAdministrativo + '_Relatorio_TempoDeUso';

export const cCHAVE_FILTROS_TEMA_ADMINISTRATIVO_RECURSOS_MAIS_UTILIZADOS =
  ECodificacao.TemaAdministrativo + '_Relatorio_RecursosMaisUtilizados';

export default class CLocal extends CStorage {
  // ---------------------------------------
  // Novidade de Atualização
  // ---------------------------------------

  public static get novidadesAtualizacaoLidas(): string[] {
    const lITem = CLocal.getItem(
      `${cCHAVE_NOVIDADE_ATUALIZACAO}_Usuario_${CSessao.sessaoAtual.obterUsuario().codigo}`,
      [],
    ) as any;

    try {
      return JSON.parse(lITem);
    } catch (error) {
      return lITem;
    }
  }
  public static set novidadesAtualizacaoLidas(pIds: string[]) {
    CLocal.setItem(
      `${cCHAVE_NOVIDADE_ATUALIZACAO}_Usuario_${CSessao.sessaoAtual.obterUsuario().codigo}`,
      JSON.stringify(pIds),
    );
  }

  // ---------------------------------------
  // Aviso de Atualização
  // ---------------------------------------
  public static obterAvisoVersao(pIdentificador: string): boolean {
    return CLocal.getItem(
      `${cCHAVE_AVISO_ATUALIZACAO}_Usuario_${CSessao.sessaoAtual.obterUsuario().codigo}_${pIdentificador}`,
      false,
    );
  }

  public static definirAvisoVersao(pIdentificador: string): void {
    CLocal.setItem(
      `${cCHAVE_AVISO_ATUALIZACAO}_Usuario_${CSessao.sessaoAtual.obterUsuario().codigo}_${pIdentificador}`,
      false,
    );
  }

  // ---------------------------------------
  // Tema da Aplicação
  // ---------------------------------------
  public static get tema(): ETemaAplicacao {
    return CLocal.getItem(cCHAVE_TEMA_APLICACAO, ETemaAplicacao.Claro);
  }
  public static set tema(pValor: ETemaAplicacao) {
    CLocal.setItem(cCHAVE_TEMA_APLICACAO, pValor);
  }

  // ---------------------------------------
  // Filtros do Tema
  // ---------------------------------------
  public static obterFiltros(pIdentificador: string): Array<IFiltroAPI<any>> {
    const chave = `${cCHAVE_FILTROS_TEMA}_Usuario_${CSessao.sessaoAtual.obterUsuario().codigo}_${pIdentificador}`;
    const item = CLocal.getItem(chave, null);

    return item ? JSON.parse(item) : [];
  }

  public static definirFiltros(pIdentificador: string, pFiltros: IFiltroAPI<any>[] = []) {
    const chave = `${cCHAVE_FILTROS_TEMA}_Usuario_${CSessao.sessaoAtual.obterUsuario().codigo}_${pIdentificador}`;
    CLocal.setItem(chave, JSON.stringify(pFiltros));
  }

  // ---------------------------------------
  // Filtros Favoritos do Usuário
  // ---------------------------------------
  public static obterFiltrosFavoritos(pIdentificador: string): TFiltroFavoritoStorage[] {
    const chave = `${cCHAVE_FILTROS_FAVORITOS}_Usuario_${CSessao.sessaoAtual.obterUsuario().codigo}_${pIdentificador}`;
    const item = CLocal.getItem(chave, null);

    return item ? JSON.parse(item) : [];
  }

  public static definirFiltrosFavoritos(pIdentificador: string, pFiltros: TFiltroFavoritoStorage[] = []) {
    const chave = `${cCHAVE_FILTROS_FAVORITOS}_Usuario_${CSessao.sessaoAtual.obterUsuario().codigo}_${pIdentificador}`;
    CLocal.setItem(chave, JSON.stringify(pFiltros));
  }

  // ---------------------------------------
  // Preferência de exibição
  // ---------------------------------------
  public static obterExibicao(pTema: ECodificacao, pGrafico: string): 'Tabela' | TTipoGraficoInterno | null {
    const chave = `${cCHAVE_CONFIG_EXIBICAO}_${CSessao.sessaoAtual.obterUsuario().codigo}_${pTema}_${pGrafico}`;
    return CLocal.getItem(chave, null);
  }

  public static definirExibicao(
    pTema: ECodificacao,
    pGrafico: string,
    pExibicao: 'Tabela' | TTipoGraficoInterno,
  ): void {
    const chave = `${cCHAVE_CONFIG_EXIBICAO}_${CSessao.sessaoAtual.obterUsuario().codigo}_${pTema}_${pGrafico}`;
    CLocal.setItem(chave, pExibicao);
  }

  // -------------------------------------
  // Clear
  // -------------------------------------
  public static clear() {
    CLocal.handle.clear();
  }
}

CLocal.handle = window.localStorage;
